import type {
    Content as MarketingContent,
    ContentUser as MarketingContentUser,
} from "@amzn/ads-discovery-theme-service-typescript-client";
import type { TemplateAssociations } from "@amzn/d16-g-cdb-publisher-portal-typescript-client";

import type { InsightFamilyWithSummary } from "./insightFromAI";

export enum SelectedContentType {
    INSIGHT_WITH_SUMMARY = "INSIGHT_WITH_SUMMARY",
    TEMPLATE = "TEMPLATE",
    MARKETING_CONTENT = "MARKETING_CONTENT",
}

export interface BaseSelectedContentInsight {
    summary?: string;
}

export interface SelectedContentOnDemandInsight {
    contentType: SelectedContentType.TEMPLATE;
    content: TemplateAssociations;
    summary?: string;
    title?: string;
}

export interface SelectedContentInsightFamilyWithSummary {
    contentType: SelectedContentType.INSIGHT_WITH_SUMMARY;
    content: InsightFamilyWithSummary;
}

export interface SelectedContentMarketingNarrative {
    contentType: SelectedContentType.MARKETING_CONTENT;
    content: MarketingContent;
    contentUsers: MarketingContentUser[];
    summary?: string;
    title?: string;
}

export type SelectedContentInsight =
    | SelectedContentOnDemandInsight
    | SelectedContentInsightFamilyWithSummary
    | SelectedContentMarketingNarrative;
